import {
  CCM_START_TIMER,
  CCM_STOP_TIMER,
  CCM_RESET_TIMER,
  SINGLE_CCM_PATIENT_DETAILS,
  START_TIMER_FROM_PATIENT_DRAWER,
  UPDATE_STOP_TIMER_NOTES,
  UPDATE_FOLLOW_UP_NOTES,
  SET_UPCOMING_APPOINTMENT_DATA,
  UPDATE_CCM_PATIENT_DEFAULT_STATE,
  UPDATE_FOLLOW_UP_DUE_DATE_AND_ASSIGNEE,
  GENERATE_DOB_FOR_CCM_USER_ROLE
} from './Index';

export const _ccmStartTimer = (
  startTime: number,
  ccmPatientId: number | null | undefined
) => async (dispatch: any) => {
  dispatch({
    type: CCM_START_TIMER,
    payload: {
      startTime: startTime,
      isTimerRunning: true,
      ccmPatientId: ccmPatientId
    }
  });
};

export const _ccmStopTimer = (
  stopTime: any,
  stopTimer?: boolean
): any => async (dispatch: any) => {
  const payload: any = {
    stopTime: stopTime
  };
  if (typeof stopTimer === 'boolean' && stopTime !== undefined) {
    payload.isTimerRunning = stopTimer;
  }
  dispatch({
    type: CCM_STOP_TIMER,
    payload: payload
  });
};

export const _ccmResetTimer = (): any => async (dispatch: any) => {
  dispatch({
    type: CCM_RESET_TIMER
  });
};

export const _startTimerfromPatientDrawer = (
  startTimerfromPatientDrawer: boolean
): any => async (dispatch: any) => {
  dispatch({
    type: START_TIMER_FROM_PATIENT_DRAWER,
    payload: {
      startTimerfromPatientDrawer: startTimerfromPatientDrawer
    }
  });
};

export const _ccmSinglePatientDetails = (
  ccmPatientId: number | null,
  patientName: string,
  accountNumber: number | null,
  isSinglePatientSearch: boolean,
  patientId?: number,
  clinicId?: number,
  guarantorId?: number,
  isPlanActive?: boolean,
  isExternalPlanActive?: boolean,
  guarantorNotificationPhone?: string
): any => async (dispatch: any) => {
  dispatch({
    type: SINGLE_CCM_PATIENT_DETAILS,
    payload: {
      ccmPatientId: ccmPatientId,
      patientName: patientName,
      accountNumber: accountNumber,
      isSinglePatientSearch: isSinglePatientSearch,
      patientId,
      clinicId,
      guarantorId,
      isPlanActive,
      guarantorNotificationPhone,
      isExternalPlanActive
    }
  });
};

export const _updateStopTimerNotes = (stopTimerNotes: string): any => async (
  dispatch: any
) => {
  dispatch({
    type: UPDATE_STOP_TIMER_NOTES,
    payload: {
      stopTimerNotes: stopTimerNotes
    }
  });
};
export const _updateFollowUpNotes = (followUpNotes: string): any => async (
  dispatch: any
) => {
  dispatch({
    type: UPDATE_FOLLOW_UP_NOTES,
    payload: {
      followUpNotes: followUpNotes
    }
  });
};

export const _updateCCMPatientTabDefaultState = (
  ccmPatientTabDefaultState: {
    showPassed?: boolean;
    clinicId?: string | number;
  } | null
): any => async (dispatch: any) => {
  dispatch({
    type: UPDATE_CCM_PATIENT_DEFAULT_STATE,
    payload: { ccmPatientTabDefaultState }
  });
};
export const _setUpcomingAppointment = (
  upcomingAppointmentData: any
): any => async (dispatch: any) => {
  dispatch({
    type: SET_UPCOMING_APPOINTMENT_DATA,
    payload: {
      upcomingAppointmentData
    }
  });
};

export const _updateFollowUpDueDateAndAssignee = (followUpDueDateAndAssigneeObj: {
  followUpDueDate?: string;
  followUpAssignee?: {
    id: number;
    label: string;
  };
}): any => async (dispatch: any) => {
  dispatch({
    type: UPDATE_FOLLOW_UP_DUE_DATE_AND_ASSIGNEE,
    payload: { followUpDueDateAndAssigneeObj }
  });
};

export const _generateDOBForCCMUserRole = (
  dobKey: string | null
): any => async (dispatch: any) => {
  dispatch({
    type: GENERATE_DOB_FOR_CCM_USER_ROLE,
    payload: { dobKey }
  });
};
